import { useCallback } from "react";
import Environment from "../../utils/Environment";
import { PRICE_API_URL } from "../../utils/ApiUrl";

const WbtcPrice = () => {
  const priceSymbol = "WBTC";

  const buildHeaders = () => ({
    "X-API-Key": Environment.PRICE_KEY,
    "Content-Type": "application/json",
  });

  const wbtcPrice = useCallback(async () => {
    try {
      const res = await fetch(
        `${PRICE_API_URL}/api/v1/markets/${encodeURIComponent(priceSymbol)}/price`,
        { headers: buildHeaders() },
      );

      const data = await res.json();
      return data?.price ?? 0;
    } catch (error) {
      throw error;
    }
  }, []);
  return { wbtcPrice: wbtcPrice };
};
export default WbtcPrice;
